import * as Server from './Server';

import { confirmAlert } from 'react-confirm-alert';

export const isEmpty = value => {
  return value === null || value === undefined || value === '' || value.toString().trim() === '';
};

export const isLogin = () => {
  if (isEmpty(localStorage.getItem('accessToken'))) {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');

    document.location.href = '/login';
  }
};

export const isNumberAndDotOnly = input => {
  const regex = /^[\d.]+$/;

  return regex.test(input);
};

export const isTimeFormat = input => {
  const timeRegex = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/;

  return timeRegex.test(input);
};

export const onlyNumber = value => {
  let val = value || '';

  val = val === '' ? val : val.replace(/[^0-9]/g, '');

  return val;
};

export const onlyNumberAndDot = value => {
  let val = value || '';

  val = val === '' ? val : val.replace(/[^0-9.]/g, '');

  return val;
};

export const onlyNumberAndDotOnly = value => {
  let val = value || '';

  val = val === '' ? val : val.replace(/[^0-9.]/g, '');

  const parts = val.split('.');

  if (parts.length > 2) {
    val = parts[0] + '.' + parts.slice(1).join('');
  }

  return val === '' ? 0 : val;
};

export const errorMsg = msg => {
  confirmAlert({
    title: msg,
    buttons: [{
      label: 'Yes'
    }]
  });
};

export const alertSuccess = () => {
  confirmAlert({
    title: 'Saved.',
    buttons: [{
      label: 'Yes'
    }]
  });
};

export const getDeviceType = () => {
  const userAgent = navigator.userAgent;

  // 일반적으로 모바일 디바이스는 'Mobi'를 포함합니다.
  if (/Mobi/i.test(userAgent)) {
    return 0;
  } else {
    // 모바일이 아닌 경우, 데스크톱 또는 태블릿인지 확인합니다.
    // 데스크톱은 'Linux', 'Windows NT', 'Macintosh' 등의 문자열을 포함합니다.
    // 태블릿은 모바일이지만 일부 브라우저는 태블릿을 명시적으로 식별하지 않을 수 있습니다.
    if (/Linux|Windows NT|Macintosh/i.test(userAgent)) {
      return 1;
    } else {
      // 나머지 경우는 태블릿으로 간주합니다.
      return 2;
    }
  }
};

export async function download(props) {
  const currentDate = await Server.fn_GetServerDate('TODAY_DATE_TIME_Excel');

  let promise = [];

  Promise.all(promise).then(() => {
    props.workbook.xlsx.writeBuffer().then((b) => {
      let a = new Blob([b]);
      let url = window.URL.createObjectURL(a);
      let elem = document.createElement('a');
      elem.href = url;
      elem.download = props.fileName + currentDate + '.xlsx';
      elem.click();
      elem.remove();
    });
  });
}

export const excelHeaderSet = props => {
  props.sheet.getCell(props.currentCol).value = props.title;
  props.sheet.getCell(props.currentCol).alignment = {
    horizontal: 'center',
    vertical: 'middle',
  }
  props.sheet.getCell(props.currentCol).fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: '075c97' },
    bgColor: { argb: '#075c97' },
  };
  props.sheet.getCell(props.currentCol).font = {
    color: { argb: 'ffffff' }
  }
  props.sheet.getCell(props.currentCol).border = {
    top: { style: 'thin', color: { argb: 'FFFFFF' } },
    left: { style: 'thin', color: { argb: 'FFFFFF' } },
    bottom: { style: 'thin', color: { argb: 'FFFFFF' } },
    right: { style: 'thin', color: { argb: 'FFFFFF' } }
  }
};
